// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"48ea600d","842":"246a4b35"}[chunkId] + ".chunk.js";
};